// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Nhdv_","header":"PatientBlock_header__2yQ-r","label":"PatientBlock_label__1gDFr","option":"PatientBlock_option__3Z9Qg"};